"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const chatNames_1 = require("../../../app/dist/utils/chatNames");
const readChatTail_1 = require("../../../app/dist/readChatTail");
exports.toolDef = {
    name: 'loom_read_chat_tail',
    description: 'Read only the NEW turns in a chat since the AI last replied — the content after the last AI block — instead of re-reading the whole chat. Use this on first touch of a chat doc in a conversation: it returns just the human turns you need to reply to, token-cheap. Returns the tail markdown (or a note if there is nothing new).',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Chat document id' },
        },
        required: ['id'],
    },
};
async function handle(root, args) {
    const id = args['id'];
    const result = await (0, readChatTail_1.readChatTail)({ id }, {
        resolveDocId: dist_1.resolveDocIdOrThrow,
        loadDoc: dist_1.loadDoc,
        aiName: chatNames_1.getAiName,
        loomRoot: root,
    });
    const text = result.hasNew ? result.tail : '(no new turns since the last AI reply)';
    return { content: [{ type: 'text', text }] };
}
